export default __webpack_public_path__ + "static/media/header.92098677.jpg";